module.exports = {
  ScormPackage: {
    background_color: "Color de Fondo",
    border_color: "Color de Borde",
    border_size: "Grosor de Borde",
    border_style: "Estilo de Borde",
    box_style: "Estilo Caja",
    opacity: "Opacidad",
    padding: "Padding",
    PluginName: "Paquete SCORM",
    radius: "Radio",
    source: "Origen",
    URL: "URL",
  },
};
